import { useRef, useState } from "react"
import styled from "styled-components"
import { SideRailResizer } from "./SideRailResizer"
import { InitialSideRailWidth, StyledOverlay, StyledSideRailFooter, StyledSideRail, StyledSideRailHeader, StyledSideRailContent, StyledSideRailInner } from "./style"
import { zIndex as commonZIndex } from "../../common/styles"
import { SideRailProps } from "./types"

const SideRail = (props: SideRailProps): JSX.Element => {
    const {
        applyButtonOnClick,
        applyButtonText,
        cancelButtonOnClick,
        cancelButtonText,
        applyAndStayButtonOnClick,
        applyAndStayButtonText,
        showApplyAndStayButton,
        content,
        disableApplyButton,
        disableCancelButton,
        headerComponent,
        headerIcon,
        headerIconClassName,
        headerText,
        hideApplyButton,
        initialWidth,
        isMax,
        isWide,
        resizeable,
        zIndex,
    } = props

    const SideRailHeader = (
        <StyledSideRailHeader>
            {headerComponent ?? (
                <div className="default-header" id="side-rail-header-text">
                    {headerIcon ? <HeaderIconContainer>{headerIcon}</HeaderIconContainer> : <i className={headerIconClassName} style={{ paddingRight: "5px" }} />}
                    {headerText}
                </div>
            )}
        </StyledSideRailHeader>
    )

    const sideRailRef = useRef<HTMLDivElement>(null)
    const [width, setWidth] = useState<number>(initialWidth || 0)

    const getInitialWidthPercentage = (): number => {
        if (isMax) return InitialSideRailWidth.Max
        if (isWide) return InitialSideRailWidth.Wide
        return InitialSideRailWidth.Normal
    }

    return (
        <>
            <StyledOverlay style={{ zIndex: zIndex ? zIndex - 1 : commonZIndex.SideRail - 1 }} />
            <StyledSideRail ref={sideRailRef} initialWidthPercentage={getInitialWidthPercentage()} width={width} style={{ zIndex: zIndex ?? commonZIndex.SideRail }} id="side-rail-wrapper">
                {resizeable && <SideRailResizer setWidth={setWidth} sideRailRef={sideRailRef} />}
                <StyledSideRailInner>
                    {SideRailHeader}
                    <StyledSideRailContent>{content}</StyledSideRailContent>
                    <StyledSideRailFooter>
                        {showApplyAndStayButton && (
                            <button className="apply" id="apply-and-stay-button" onClick={applyAndStayButtonOnClick} disabled={disableApplyButton} type="button">
                                {applyAndStayButtonText ?? "Apply & Continue"}
                            </button>
                        )}
                        {!hideApplyButton && (
                            <button className="apply" id="apply-button" onClick={applyButtonOnClick} disabled={disableApplyButton} type="button">
                                {applyButtonText ?? "Apply"}
                            </button>
                        )}
                        <button id="cancel-button" onClick={cancelButtonOnClick} type="button" disabled={disableCancelButton}>
                            {cancelButtonText ?? "Cancel"}
                        </button>
                    </StyledSideRailFooter>
                </StyledSideRailInner>
            </StyledSideRail>
        </>
    )
}

const HeaderIconContainer = styled.div`
    width: 20px;
    margin-right: 8px;
    display: flex;
`

export default SideRail
